import Components from '../../Components';
import { receptionRoleAccess } from '../../Core/Utils/userPermissions';

const { containerTypes } = Components.Routes;

const RouteConfig = {
  path: '/home/reception/packagealerts',
  exact: true,
  name: 'navigation.menu.package',
  private: true,
  type: containerTypes.PAGE,
  shortPathName: 'navigation.menu.package',
  requiresMemberPortalAccess: true,
  isAuthorized: ({ profile }) => {
    return receptionRoleAccess.accessReception({ profile });
  },
};

export default RouteConfig;
